import { render, staticRenderFns } from "./PkgTariffMenu.vue?vue&type=template&id=06494121&"
import script from "./PkgTariffMenu.vue?vue&type=script&lang=js&"
export * from "./PkgTariffMenu.vue?vue&type=script&lang=js&"
import style0 from "./PkgTariffMenu.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "PkgTariffMenu.vue"
export default component.exports